import { queryOptions } from '@tanstack/react-query';
import { axios } from '@/lib/utils/axios';
import type { WorkPackage } from '../../common/work-package';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type WorkPackageSuccessResponseType = WorkPackage;

async function getWorkPackage(id: string, deleted: boolean): Promise<WorkPackageSuccessResponseType | null> {
	const response = await axios.get(
		`${API_URLS.WORK_PACKAGES.INDEX}/${id}`,
		deleted ? { params: { deleted: true } } : undefined,
	);
	return getResponse<WorkPackageSuccessResponseType>(response.data);
}

/** With `deleted`, loads a deleted package (with the lines deleted along) as a read-only preview (GH #331). */
export function getWorkPackageOptions(id: string, enabled = true, { deleted = false }: { deleted?: boolean } = {}) {
	return queryOptions({
		queryKey: deleted ? ['work-packages', id, 'deleted'] : ['work-packages', id],
		queryFn: () => getWorkPackage(id, deleted),
		enabled: enabled && !!id,
	});
}
